
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const SKILL_FIELDS = [
  {
    id: "title",
    label: "Skill Name",
    placeHolder: "Enter Skill Name",
    type: "text",
    md: 12,
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    label: "Description",
    placeHolder: "Enter Description",
    type: "text",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];